import { DEFAULT_PAGINATION } from '../../../../../common/query/defaults'
import { ProviderListQuery } from './query.types'

export const DEFAULT_PROVIDER_LIST_QUERY: ProviderListQuery = {
  ...DEFAULT_PAGINATION,
}
